<template>
  <div class="course">
    <TabPageLayout activeCode="yizhongkecheng" :activeId="activeTabId" v-if="activeTabId">
      <div class="container schoolCourse">
        <div
          class="div_mod div_mod1"
          v-for="(block, index) in blocks"
          :key="block.id"
        >
          <div class="div_tit">
            <h2>{{ block.title }}</h2>
          </div>
          <!-- 栏目简介 -->
          <div class="div_text" v-html="block?.bz"></div>

          <div class="" v-if="index === 1">
            <!-- <CourseTypeBlock :courseType="courseType" /> -->
            <!-- 课程封面 -->
            <!-- <div class="lunbo kcfmlunbo">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="item in courseCoverList"
                    :key="item.id"
                  >
                    <img :src="item.files" alt="" />
                  </div>
                </div>
              </div>
              <div class="direction">
                <span class="s_prev"><i></i></span>
                <span class="s_next"><i></i></span>
              </div>
            </div> -->
          </div>

          <ArticleCard2
            v-for="(article, index) in blockArticles[index]"
            :key="article.id"
            :article="article"
            activeCode="yizhongkecheng"
            :class="{
              dlSp: (index + 1) % 2 === 0,
            }"
          />
        </div>
        <div class="div_text">
          <div v-html="zhsjkcArr[0]?.bz"></div>
          <div class="lunbo lunbo0">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="aside in zykcArr" :key="aside.id">
                  <div>
                    <img :src="aside.bgimg" alt="" />
                    <p>{{ aside.title }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="direction">
              <span class="s_prev"><i></i></span>
              <span class="s_next"><i></i></span>
            </div>
          </div>
          <div v-html="zhsjkcArr[1]?.bz"></div>
          <div class="lunbo lunbo1">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="aside in zckcArr" :key="aside.id">
                  <div>
                    <img :src="aside.bgimg" alt="" />
                    <p>{{ aside.title }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="direction">
              <span class="s_prev"><i></i></span>
              <span class="s_next"><i></i></span>
            </div>
          </div>
          <div v-html="zhsjkcArr[2]?.bz"></div>
          <div class="lunbo lunbo2">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="aside in sfkcArr" :key="aside.id">
                  <div>
                    <img :src="aside.bgimg" alt="" />
                    <p>{{ aside.title }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="direction">
              <span class="s_prev"><i></i></span>
              <span class="s_next"><i></i></span>
            </div>
          </div>
          <div v-html="zhsjkcArr[3]?.bz"></div>
          <div class="lunbo lunbo3">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="aside in xykcArr" :key="aside.id">
                  <div>
                    <img :src="aside.bgimg" alt="" />
                    <p>{{ aside.title }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="direction">
              <span class="s_prev"><i></i></span>
              <span class="s_next"><i></i></span>
            </div>
          </div>
        </div>
      </div>
    </TabPageLayout>
    <CommonDialog
      :visible.sync="oDialog.visible"
      :titleText.sync="oDialog.title"
      :showCancel="false"
      :showOK="false"
      :size="oDialog.size"
    >
      <SwiperContainer v-if="oDialog.visible" :typeId="oDialog.typeId + ''" showContent />
    </CommonDialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ArticleCard2 from './components/ArticleCard2.vue'
import TabPageLayout from './components/TabPageLayout.vue'
import portalApi from '../../../lvya-common/src/api/eos/portal'
import { useGetCategories } from './utils/useGetCategories'
import CourseTypeBlock from './components/CourseTypeBlock.vue'
import CommonDialog from '../../../lvya-common/src/coms-web/dialog/CommonDialog.vue'
import SwiperContainer from './components/SwiperContainer.vue'

export default {
  components: {
    TabPageLayout,
    ArticleCard2,
    CourseTypeBlock,
    CommonDialog,
    SwiperContainer,
  },
  computed: {
    ...mapState({
      nav: (state) => state.yzsyStore.nav,
    }),
    typeId() {
      return (
        this.nav?.find((item) => item.code === 'yizhongkecheng')?.stypes[0]
          ?.id || undefined
      )
    },
    schoolYear() {},
    activeTabId() {
      return this.typeId
    },
  },
  data() {
    return {
      blocks: [],
      blockArticles: [],
      courseType: [],
      courseCover: null,
      courseCoverList: [],
      zhsjkcArr: [],
      zykcArr: [],
      zckcArr: [],
      sfkcArr: [],
      xykcArr: [],
      oDialog: {
        visible: false,
        title: ' ',
        typeId: null,
      },
      swiper: null,
    }
  },
  methods: {
    async getBlocks() {
      const categories = await useGetCategories(this.typeId)
      // console.log({ categories })
      this.blocks = categories.list
      let resArr = await useGetCategories(categories.list[5].id)
      this.zhsjkcArr = resArr?.list || []
      // console.log(resArr, 'resArrresArr')
      for (let index = 0; index < resArr?.list?.length; index++) {
        console.log(index, 'index11111')
        const nav = resArr?.list[index]
        if (index === 0) {
          const resData = await portalApi.getTypeListByPage({ pId: nav.id, pageNum: '1', pageSize: '99999', })
          this.zykcArr = resData.list
        } else if (index === 1) {
          const resData = await portalApi.getTypeListByPage({ pId: nav.id, pageNum: '1', pageSize: '99999', })
          this.zckcArr = resData.list
        } else if (index === 2) {
          const resData = await portalApi.getTypeListByPage({ pId: nav.id, pageNum: '1', pageSize: '99999', })
          this.sfkcArr = resData.list
        } else if (index === 3) {
          const resData = await portalApi.getTypeListByPage({ pId: nav.id, pageNum: '1', pageSize: '99999', })
          this.xykcArr = resData.list
        }
      }
    },
    async getArticles() {
      // const portalSchoolInfo = JSON.parse(
      //   localStorage.getItem('portalSchoolInfo')
      // )
      const articles = []
      for (const block of this.blocks) {
        // console.log(block, 'block')
        let reqData = {
          noSchoolId: true,
          schoolId: '7',
          pageNum: 1,
          pageSize: 999,
          typeId: block.id,
          isContent: 'Y',
          applyState: 'Y',
        }
        let resData = await portalApi.getArtsByPage(reqData)
        // console.log(resData, 'articles')
        articles.push(resData?.list)
        // console.log(articles, 'articles')
      }
      this.blockArticles = articles
    },
    // ****************课程封面相关开始
    // async getCourseType() {
    //   const resData = await useGetCategories(this.blocks[1].id)
    //   // console.log(resData, 'courseType')

    //   this.courseType = resData.list.filter(item => item.sort !== 0)
    //   this.courseCover = resData.list.filter(item => item.sort === 0)[0]
    //   this.$store.commit('setCourseTypes', this.courseType)
    //   await this.getCourseCoverList()
    // },
    // async getCourseCoverList() {
    //   // const portalSchoolInfo = JSON.parse(
    //   //   localStorage.getItem('portalSchoolInfo')
    //   // )
    //   let reqData = {
    //     noSchoolId: true,
    //     schoolId: '7',
    //     pageNum: 1,
    //     pageSize: 999,
    //     typeId: this.courseCover.id,
    //     isContent: 'Y',
    //     applyState: 'Y',
    //   }
    //   let resData = await portalApi.getArtsByPage(reqData)
    //   // console.log(resData, 'courseCoverList')
    //   this.courseCoverList = resData?.list
    // },
    // ****************课程封面相关结束
    async toCourseTypePage(typeId) {
      this.$router.push({
        path: '/portalYZSYCourseNormalDetail',
        query: {
          typeId,
        },
      })
    },
    initSwiper() {
      this.zhsjkcArr.forEach((ele, index) => {
        console.log(index)
        this.swiper = new Swiper(`.lunbo${index} .swiper-container`, {
          watchSlidesVisibility: true,
          slidesPerView: 1,
          spaceBetween: 30,
          loop: false,
          navigation: {
            nextEl: `.lunbo${index} .s_next`,
            prevEl: `.lunbo${index} .s_prev`,
          },
          breakpoints: {
            1023: {
              // 当屏幕宽度大于等于102333
              slidesPerView: 2,
              spaceBetween: 30,
            },
          },
        })
      })
    },
    handleDialogOpen(item) {
      console.log(item, ' item')
      this.oDialog.title = item.title
      this.oDialog.typeId = item.id
      this.oDialog.visible = true
    },
  },
  async mounted() {
    await this.getBlocks()
    await this.getArticles()
    // await this.getCourseType() // 课程封面相关

    new Swiper('.kcfmlunbo .swiper-container', {
      loop: true,
      slidesPerView: 1, // 一行显示3个
      spaceBetween: 30,
      navigation: {
        nextEl: '.lunbo .s_next',
        prevEl: '.lunbo .s_prev',
      },

      breakpoints: {
        1024: {
          // 当屏幕宽度大于等于320
          slidesPerView: 1,
          spaceBetween: 30,
        },
      },
    })
    this.initSwiper()
  },
}
</script>

<style lang="less" scoped>
@import "./style/course.css";
@import "./style/common.css";
@import "./style/global.css";

// .lunbo {
//   background: transparent;
// }
.schoolCourse{
  /deep/ p img{
    width: auto;
    max-width: 100%;
  }
}
.div_text{
  .lunbo{
    margin: 40px 0;
    .swiper-slide .imgbox {
      position: relative;
      cursor: pointer;
      overflow: hidden;
    }
    .swiper-slide .imgbox img {
      transform: scale(1);
      transition: transform 0.3s linear;
    }
    .swiper-slide .imgbox:hover img {
        transform: scale(1.1);
    }
    .swiper-slide .imgbox:hover::after {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url(./images/aboutus/s_icon1.png);
      background-color: rgba(0, 0, 0, 0.6);
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  // /deep/ .imgbox img{
  //   min-height: 390PX;
  //   max-height: 450px;
  // }
}
// @media screen and (max-width: 1023px) {
//   /deep/ .imgbox img{
//     height: auto !important;
//   }
// }
</style>
